import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  text-align: left;
  height: ${(props) => !props.emptySchedule && '100%'};
  overflow: hidden;
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
